import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';
import * as Constants from '../../components/api/constants';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function HistoryStartDate() {
  const state = useContext(MainContext).state;
  const r7 = state.R7.split(',');
  const deviceId = state.selectedDevice;

  const sendCommand = (command, value) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value,
      }),
      credentials: 'include',
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 8000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 4000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 9000);
        } else {
          toast.error('Send failed. Please try again', {
            position: 'top-right',
            autoClose: 5000,
          });
        }
      })
      .catch((error) => console.log('request failed', error));
  };

  const onClickListener = () => {
    sendCommand('clearStartDate', '');
  };

  return (
    <React.Fragment>
      <ToastContainer />

      {/* Title matching your dashboard */}
      <Typography
        component="h2"
        variant="h6"
        sx={{ color: 'white', fontWeight: 600, mb: 1 }}
      >
        Start Date
      </Typography>

      {/* Tile wrapper */}
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.08)',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            component="p"
            variant="h4"
            sx={{ color: 'white', fontWeight: 600 }}
          >
            {r7[8]}/{r7[9]}/{r7[10]}
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: 'rgba(255,255,255,0.6)', mt: 0.5 }}
          >
            Start Date
          </Typography>
        </Box>

        <Button
          variant="outlined"
          size="small"
          onClick={onClickListener}
          sx={{
            color: 'white',
            borderColor: 'rgba(255,255,255,0.5)',
            textTransform: 'none',
            px: 3,
            '&:hover': {
              borderColor: 'white',
              backgroundColor: 'rgba(255,255,255,0.06)',
            },
          }}
        >
          Clear
        </Button>
      </Paper>
    </React.Fragment>
  );
}
